
export function handleAddProduct(
  id: string,
  values: Record<string, any>,
  setFieldValue: (field: string, value: any) => void
): void {
  const alreadySelected = values.products.includes(id);
  const updated = alreadySelected
    ? values.products.filter((item: string) => item !== id)
    : [...values.products, id];

  setFieldValue('products', updated);
  if (!updated.includes(id)) {
    const keyMap: Record<string, string> = {
      '1': 'tr_balance',
      '2': 'hp_balance',
      '3': 'sr_balance',
      '4': 'cr_balance',
      '5': 'cm_balance',
      '6': 'hv_balance',
      '7': 'lw_balance',
    };
    setFieldValue(keyMap[id], 0);
  }
}
